import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export const HomeCTA = () => (
  <section className="py-24 bg-white" data-testid="cta-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="relative rounded-3xl bg-gradient-to-r from-[#3b5998] to-[#00bcd4] p-12 lg:p-16 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl -translate-y-1/2 translate-x-1/2"></div>
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl translate-y-1/2 -translate-x-1/2"></div>
        </div>
        <div className="relative text-center">
          <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-white mb-4">
            Ready to Unlock Your Financial Potential?
          </h2>
          <p className="text-white/80 max-w-2xl mx-auto mb-8">
            Schedule a consultation with our experts today and discover how we can help 
            you access government subsidies and optimal financing solutions.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link
              to="/contact"
              data-testid="cta-contact"
              className="px-8 py-4 bg-white text-[#3b5998] rounded-full font-medium hover:bg-white/90 transition-colors inline-flex items-center gap-2"
            >
              Schedule Consultation
              <ArrowRight size={18} />
            </Link>
            <a
              href="tel:+917791093252"
              data-testid="cta-call"
              className="px-8 py-4 border-2 border-white text-white rounded-full font-medium hover:bg-white/10 transition-colors"
            >
              Call Now
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
);
